import {useQuery} from 'react-query'
import {ExitinguserEditModalForm} from './ExitinguserEditModalForm'
// import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import { QUERIES, isNotEmpty } from '../../../../../_metronic/helpers'
import { getExitinguserById } from '../core/_requests'
// import { getExitinguserById } from '../../../apps/exitinguser-management/exitingusers-list/core/_requests'
// import {getExitinguserById} from '../core/_requests'

const ExitinguserEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: exitinguser,
    error,
  } = useQuery(
    `${QUERIES.EXITINGUSERS_LIST}-exitinguser-${itemIdForUpdate}`,
    () => {
      return getExitinguserById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <ExitinguserEditModalForm isExitinguserLoading={isLoading} exitinguser={{id: undefined}} />
  }

  if (!isLoading && !error && exitinguser) {
    return <ExitinguserEditModalForm isExitinguserLoading={isLoading} exitinguser={exitinguser} />
  }

  return null
}

export {ExitinguserEditModalFormWrapper}
